var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-toolbar", {
        attrs: { app: "", color: "primary", dark: "", flat: "" }
      }),
      _vm._v(" "),
      _c(
        "v-container",
        { staticClass: "pa-0", attrs: { "align-center": "" } },
        [
          _c(
            "v-layout",
            [
              _c(
                "v-flex",
                { attrs: { md4: "" } },
                [
                  _c(
                    "v-list",
                    [
                      _c("v-subheader", [
                        _vm._v("\n            You\n          ")
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        { attrs: { avatar: "" } },
                        [
                          _c(
                            "v-list-tile-avatar",
                            [_c("v-icon", [_vm._v("label")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  "\n                Daily kill\n                "
                                ),
                                _c("strong", { staticClass: "pull-right" }, [
                                  _vm._v(
                                    "\n                  8000\n                "
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        { attrs: { avatar: "" } },
                        [
                          _c(
                            "v-list-tile-avatar",
                            [_c("v-icon", [_vm._v("attach_money")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  "\n                Full Price Freight\n                "
                                ),
                                _c("strong", { staticClass: "pull-right" }, [
                                  _vm._v(
                                    "\n                  $3.75\n                "
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        { attrs: { avatar: "" } },
                        [
                          _c(
                            "v-list-tile-avatar",
                            [_c("v-icon", [_vm._v("label")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  "\n                Avg. Live Weight\n                "
                                ),
                                _c("strong", { staticClass: "pull-right" }, [
                                  _vm._v(
                                    "\n                  1250\n                "
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        { attrs: { avatar: "" } },
                        [
                          _c(
                            "v-list-tile-avatar",
                            [_c("v-icon", [_vm._v("label")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  "\n                Long Haul Weight\n                "
                                ),
                                _c("strong", { staticClass: "pull-right" }, [
                                  _vm._v(
                                    "\n                  48000\n                "
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        { attrs: { avatar: "" } },
                        [
                          _c(
                            "v-list-tile-avatar",
                            [_c("v-icon", [_vm._v("label")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  "\n                Head Per Delivery\n                "
                                ),
                                _c("strong", { staticClass: "pull-right" }, [
                                  _vm._v(
                                    "\n                  38\n                "
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { staticClass: "px-3", attrs: { md4: "" } },
                [
                  _c(
                    "v-list",
                    [
                      _c("v-subheader", [
                        _vm._v("\n            Knobs/Adjustments\n          ")
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        { attrs: { avatar: "" } },
                        [
                          _c(
                            "v-list-tile-avatar",
                            [_c("v-icon", [_vm._v("attach_money")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  "\n                Freight Savings\n                "
                                ),
                                _c("strong", { staticClass: "pull-right" }, [
                                  _vm._v(
                                    "\n                  $0.25\n                "
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        { attrs: { avatar: "" } },
                        [
                          _c(
                            "v-list-tile-avatar",
                            [_c("v-icon", [_vm._v("label")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  "\n                LH Miles\n                "
                                ),
                                _c("strong", { staticClass: "pull-right" }, [
                                  _vm._v(
                                    "\n                  600\n                "
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        { attrs: { avatar: "" } },
                        [
                          _c(
                            "v-list-tile-avatar",
                            [_c("v-icon", [_vm._v("label")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  "\n                LH %\n                "
                                ),
                                _c("strong", { staticClass: "pull-right" }, [
                                  _vm._v(
                                    "\n                  35%\n                "
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md4: "" } },
                [
                  _c(
                    "v-list",
                    [
                      _c("v-subheader", [
                        _vm._v(
                          "\n            Savings Opportunities\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        { attrs: { avatar: "" } },
                        [
                          _c(
                            "v-list-tile-avatar",
                            [_c("v-icon", [_vm._v("label")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  "\n                LH Daily Kill\n                "
                                ),
                                _c("strong", { staticClass: "pull-right" }, [
                                  _vm._v(
                                    "\n                  2800\n                "
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        { attrs: { avatar: "" } },
                        [
                          _c(
                            "v-list-tile-avatar",
                            [_c("v-icon", [_vm._v("label")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  "\n                LH Daily Loads\n                "
                                ),
                                _c("strong", { staticClass: "pull-right" }, [
                                  _vm._v(
                                    "\n                  74\n                "
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        { attrs: { avatar: "" } },
                        [
                          _c(
                            "v-list-tile-avatar",
                            [_c("v-icon", [_vm._v("attach_money")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  "\n                Load Rate: Full\n                "
                                ),
                                _c("strong", { staticClass: "pull-right" }, [
                                  _vm._v(
                                    "\n                  $2,250.00\n                "
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        { attrs: { avatar: "" } },
                        [
                          _c(
                            "v-list-tile-avatar",
                            [_c("v-icon", [_vm._v("attach_money")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  "\n                Load Rate: " +
                                    _vm._s(_vm.$t("site-title.brief")) +
                                    "\n                "
                                ),
                                _c("strong", { staticClass: "pull-right" }, [
                                  _vm._v(
                                    "\n                  $2,100.00\n                "
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        { attrs: { avatar: "" } },
                        [
                          _c(
                            "v-list-tile-avatar",
                            [_c("v-icon", [_vm._v("attach_money")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  "\n                Load Rate: Savings\n                "
                                ),
                                _c("strong", { staticClass: "pull-right" }, [
                                  _vm._v(
                                    "\n                  $150.00\n                "
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            [
              _c("v-flex", { attrs: { md4: "" } }),
              _vm._v(" "),
              _c(
                "v-flex",
                { staticClass: "px-3", attrs: { md4: "" } },
                [
                  _c(
                    "v-card",
                    [
                      _c("v-toolbar", { attrs: { color: "accent", dark: "" } }),
                      _vm._v(" "),
                      _c(
                        "v-list",
                        [
                          _c(
                            "v-list-tile",
                            { attrs: { avatar: "" } },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [_c("v-icon", [_vm._v("attach_money")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v(
                                      "\n                Per-Head Savings\n                "
                                    ),
                                    _c(
                                      "strong",
                                      { staticClass: "pull-right" },
                                      [
                                        _vm._v(
                                          "\n                  $3.95\n                "
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { avatar: "" } },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [_c("v-icon", [_vm._v("attach_money")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v(
                                      "\n                Daily Savings\n                "
                                    ),
                                    _c(
                                      "strong",
                                      { staticClass: "pull-right" },
                                      [
                                        _vm._v(
                                          "\n                  $11,052.63\n                "
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { avatar: "" } },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [_c("v-icon", [_vm._v("attach_money")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v(
                                      "\n                Weekly Savings\n                "
                                    ),
                                    _c(
                                      "strong",
                                      { staticClass: "pull-right" },
                                      [
                                        _vm._v(
                                          "\n                  $55,263.16\n                "
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { avatar: "" } },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [_c("v-icon", [_vm._v("attach_money")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v(
                                      "\n                Yearly Savings\n                "
                                    ),
                                    _c(
                                      "strong",
                                      { staticClass: "pull-right" },
                                      [
                                        _vm._v(
                                          "\n                  $2,873,684.21\n                "
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-flex", { attrs: { md4: "" } })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isLtnAdmin
        ? _c(
            "v-container",
            [
              _c("v-layout", { attrs: { row: "" } }, [
                _c("h3", [_vm._v("Admin Config")])
              ]),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { row: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { right: "", loading: _vm.loadingBtn },
                      on: { click: _vm.saveChanges }
                    },
                    [_vm._v("\n        Save\n      ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    { attrs: { md4: "" } },
                    [
                      _c(
                        "v-list",
                        [
                          _c("v-subheader", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("site-title.brief")) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { avatar: "" } },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [_c("v-icon", [_vm._v("label")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-text-field", {
                                    attrs: { label: "Dispatch Fee %" },
                                    model: {
                                      value: _vm.data.dispatch_fee,
                                      callback: function($$v) {
                                        _vm.$set(_vm.data, "dispatch_fee", $$v)
                                      },
                                      expression: "data.dispatch_fee"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { avatar: "" } },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [_c("v-icon", [_vm._v("label")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-text-field", {
                                    attrs: { label: "Dispatch Fee Max" },
                                    model: {
                                      value: _vm.data.dispatch_fee_max,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data,
                                          "dispatch_fee_max",
                                          $$v
                                        )
                                      },
                                      expression: "data.dispatch_fee_max"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { avatar: "" } },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [_c("v-icon", [_vm._v("label")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c(
                                    "v-text-field",
                                    {
                                      attrs: { label: "Dispatch Fee Min" },
                                      model: {
                                        value: _vm.data.dispatch_fee_min,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.data,
                                            "dispatch_fee_min",
                                            $$v
                                          )
                                        },
                                        expression: "data.dispatch_fee_min"
                                      }
                                    },
                                    [_vm._v(">\n              ")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { avatar: "" } },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [_c("v-icon", [_vm._v("label")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c(
                                    "v-text-field",
                                    {
                                      attrs: { label: "Factor Fee" },
                                      model: {
                                        value: _vm.data.factor_fee,
                                        callback: function($$v) {
                                          _vm.$set(_vm.data, "factor_fee", $$v)
                                        },
                                        expression: "data.factor_fee"
                                      }
                                    },
                                    [_vm._v(">\n              ")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { avatar: "" } },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [_c("v-icon", [_vm._v("label")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-text-field", {
                                    attrs: { label: "Loads % Factored" },
                                    model: {
                                      value: _vm.data.loads_factored,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data,
                                          "loads_factored",
                                          $$v
                                        )
                                      },
                                      expression: "data.loads_factored"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-flex", { staticClass: "px-3", attrs: { md4: "" } }),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { md4: "" } },
                    [
                      _c(
                        "v-list",
                        [
                          _c("v-subheader", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("site-title.brief")) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { avatar: "" } },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [_c("v-icon", [_vm._v("label")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-text-field", {
                                    attrs: { label: "Load Dispatch" },
                                    model: {
                                      value: _vm.data.load_dispatch,
                                      callback: function($$v) {
                                        _vm.$set(_vm.data, "load_dispatch", $$v)
                                      },
                                      expression: "data.load_dispatch"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { avatar: "" } },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [_c("v-icon", [_vm._v("label")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-text-field", {
                                    attrs: { label: "Daily Load Dispatch" },
                                    model: {
                                      value: _vm.data.daily_load_dispatch,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data,
                                          "daily_load_dispatch",
                                          $$v
                                        )
                                      },
                                      expression: "data.daily_load_dispatch"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { avatar: "" } },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [_c("v-icon", [_vm._v("label")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-text-field", {
                                    attrs: { label: "Weekly Load Dispatch" },
                                    model: {
                                      value: _vm.data.weekly_load_dispatch,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data,
                                          "weekly_load_dispatch",
                                          $$v
                                        )
                                      },
                                      expression: "data.weekly_load_dispatch"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { avatar: "" } },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [_c("v-icon", [_vm._v("label")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-text-field", {
                                    attrs: { label: "Yearly Load Dispatch" },
                                    model: {
                                      value: _vm.data.yearly_load_dispatch,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data,
                                          "yearly_load_dispatch",
                                          $$v
                                        )
                                      },
                                      expression: "data.yearly_load_dispatch"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { avatar: "" } },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [_c("v-icon", [_vm._v("label")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-text-field", {
                                    attrs: { label: "Factor Amount" },
                                    model: {
                                      value: _vm.data.factor_amount,
                                      callback: function($$v) {
                                        _vm.$set(_vm.data, "factor_amount", $$v)
                                      },
                                      expression: "data.factor_amount"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { avatar: "" } },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [_c("v-icon", [_vm._v("label")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-text-field", {
                                    attrs: { label: "Loads Factored" },
                                    model: {
                                      value: _vm.data.loads_factored,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data,
                                          "loads_factored",
                                          $$v
                                        )
                                      },
                                      expression: "data.loads_factored"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { avatar: "" } },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [_c("v-icon", [_vm._v("label")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-text-field", {
                                    attrs: { label: "Daily Factoring" },
                                    model: {
                                      value: _vm.data.daily_factoring,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data,
                                          "daily_factoring",
                                          $$v
                                        )
                                      },
                                      expression: "data.daily_factoring"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { avatar: "" } },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [_c("v-icon", [_vm._v("label")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-text-field", {
                                    attrs: { label: "Weekly Factoring" },
                                    model: {
                                      value: _vm.data.weekly_factoring,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data,
                                          "weekly_factoring",
                                          $$v
                                        )
                                      },
                                      expression: "data.weekly_factoring"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { avatar: "" } },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [_c("v-icon", [_vm._v("label")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-text-field", {
                                    attrs: { label: "Yearly Factoring" },
                                    model: {
                                      value: _vm.data.yearly_factoring,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data,
                                          "yearly_factoring",
                                          $$v
                                        )
                                      },
                                      expression: "data.yearly_factoring"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { attrs: { avatar: "" } },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [_c("v-icon", [_vm._v("label")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-text-field", {
                                    attrs: { label: "Bottom Line" },
                                    model: {
                                      value: _vm.data.bottom_line,
                                      callback: function($$v) {
                                        _vm.$set(_vm.data, "bottom_line", $$v)
                                      },
                                      expression: "data.bottom_line"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ea9b3a72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea9b3a72","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BeefPlantNumbers.vue
// module id = null
// module chunks = 